import { AUTH, CUSTOMER, GETORDERBYID, USER, WAIVER } from '../../services/apis';
import fetcher from '../../services/fetcher';

class WaiverProvider {
    static async doWaiver() {
        const res = {};
        return res;
    }

    static async doSubmission(payload) {
        const request = `${WAIVER.API_WAIVER}/register`;
        return fetcher.post(request, payload);
    }

    static async doCheckEmailOrPhone(payload) {
        const request = `${WAIVER.API_WAIVER}/check-email-phone`;
        return fetcher.post(request, payload);
    }

    static async doPaymentProcess(payload) {
        const request = `${CUSTOMER.API_CUSTOMER}/member-registration`;
        return fetcher.post(request, payload);
        // console.log({payload})
        // return {acknowledge:1, message:''}
    }

    static async doUploadImage(payload) {
        const formData = new FormData();
        formData.append('image', payload);
        const baseUrlUpload = 'https://assets.scap.co.id/upload-file';
        return fetcher.postUpload(baseUrlUpload, formData);
    }

    static async doSendOTP(payload) {
        const request = `${AUTH.API_AUTH}/send-otp`;
        return fetcher.post(request, payload);
    }

    static async doVerifyOTP(payload) {
        const request = `${AUTH.API_AUTH}/verify-otp`;
        return fetcher.post(request, payload);
    }

    static async doSetPassword(payload) {
        const request = `${AUTH.API_AUTH}/set-password`;
        return fetcher.post(request, payload);
    }

    static async doLogin(payload) {
        const request = `${AUTH.API_AUTH}/login`;
        return fetcher.post(request, payload);
    }

    static async doForgotPassword(payload) {
        const request = `${AUTH.API_AUTH}/forgot-password`;
        return fetcher.post(request, payload);
    }

    static async doGetOrderById(payload) {
        const request = `${GETORDERBYID.API_ORDER}/${payload.orderId || ''}`;
        return fetcher.get(request);
    }

    static async doUpdateWaiver(payload) {
        const request = USER.API_USER_WAIVER_UPDATE;
        return fetcher.patch(request, payload);
    }

    static async doUpdateWaiverPhone(payload) {
        const request = USER.API_USER_WAIVER_UPDATE_PHONE;
        return fetcher.patch(request, payload);
    }

    static async doUpdateWaiverEmail(payload) {
        const request = USER.API_USER_WAIVER_UPDATE_EMAIL;
        return fetcher.patch(request, payload);
    }

    static async doCreateWaiverChild(payload) {
        const request = USER.API_USER_WAIVER_CREATE_CHILD;
        return fetcher.post(request, payload);
    }

    static async doUpdateWaiverChild(payload) {
        const request = USER.API_USER_WAIVER_UPDATE_CHILD;
        return fetcher.patch(request, payload);
    }

    static async doDeleteWaiverChild(payload) {
        const request = USER.API_USER_WAIVER_DELETE_CHILD;
        return fetcher.delete(request, payload);
    }
}

export default WaiverProvider;
